
import TreeApi from './src/tree-api'
import ProductApi from './src/product-api'
import OrgApi from './src/org-api'
import OrgProductApi from './src/org-product-api'
import OrgUserApi from './src/org-user-api'
import UserApi from './src/user-api'
import MenuApi from './src/menu-api'
import RoleApi from './src/role-api'
import RoleProductMenuApi from './src/roleproductmenu-api'
import UserRoleApi from './src/user-role-api'

let apis = {
   TreeApi,
   ProductApi,
   OrgApi,
   OrgProductApi,
   OrgUserApi,
   UserApi,
   MenuApi,
   RoleApi,
   RoleProductMenuApi,
   UserRoleApi
};

export default apis;
